import { useCallback } from "react";
import { useRouter } from "next/router";
import { useModal } from "@/hooks";
import { Button } from "@/components/Buttons/index";
import routes from "@/lib/routes";
import modalStyles from "@/styles/Modal.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function LogoutModal() {
  const router = useRouter();
  const {
    hideModal
  } = useModal();
  const logout = useCallback(() => {
    hideModal();
    router.push(routes.logout);
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: modalStyles.logout,
    children: [/*#__PURE__*/_jsx("p", {
      className: modalStyles.text,
      children: "\u30ED\u30B0\u30A2\u30A6\u30C8\u3057\u307E\u3059\u304B\uFF1F"
    }), /*#__PURE__*/_jsxs("div", {
      className: modalStyles.buttons,
      children: [/*#__PURE__*/_jsx(Button, {
        type: "button",
        fillColor: true,
        large: true,
        fillGray: true,
        borderGray: true,
        onClick: hideModal,
        children: "\u30AD\u30E3\u30F3\u30BB\u30EB"
      }), /*#__PURE__*/_jsx(Button, {
        type: "button",
        fillColor: true,
        large: true,
        onClick: logout,
        children: "\u30ED\u30B0\u30A2\u30A6\u30C8"
      })]
    })]
  });
}